import { defineComponent as _defineComponent } from 'vue';
import { useSettingsStore } from '@/store/modules/settings';

import { onUnmounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    fixedHeader: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showTabs: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const settingsStore = useSettingsStore();
    const {
      foldSideBar,
      openSideBar
    } = settingsStore;
    foldSideBar();
    onUnmounted(() => {
      openSideBar();
    });
    const __returned__ = {
      settingsStore,
      foldSideBar,
      openSideBar
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});